import type { RequestParams } from '@/shared/api';
import type { WarehouseItemListParams } from '../model/types';

export const WAREHOUSE_KEYS = {
  all: ['warehouse'] as const,
  list: (params?: RequestParams) => [...WAREHOUSE_KEYS.all, 'list', params] as const,
  detail: (id: number) => [...WAREHOUSE_KEYS.all, 'detail', id] as const,
  itemList: (params?: WarehouseItemListParams) => [...WAREHOUSE_KEYS.all, 'item-list', params] as const,
};
